import { renderToString } from "react-dom/server";
import { StaticRouter } from "react-router-dom/server";
import type { ComponentType } from "react";

// Eager imports only — React.lazy is unusable under renderToString because
// Suspense falls back to the placeholder instead of awaiting the chunk.
// The client still lazy-loads via App.tsx's React.lazy calls; this file
// only runs at build time.
import { Landing } from "./pages/Landing";
import { Audit } from "./pages/Audit";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { Impressum } from "./pages/Impressum";
import { ComplianceScore } from "./pages/ComplianceScore";
import { Blog } from "./pages/Blog";
import { BlogAfirComplianceGuide2026 } from "./pages/BlogAfirComplianceGuide2026";
import { BlogEichrechtKonformitaetChecklist } from "./pages/BlogEichrechtKonformitaetChecklist";
import { BlogCpmsBuyerChecklist } from "./pages/BlogCpmsBuyerChecklist";
import { FAQ } from "./pages/FAQ";
import {
  AfirComplianceSoftware,
  EichrechtCompliance,
  LadeinfrastrukturCompliance,
} from "./pages/GeoCompliancePages";

const ROUTES: Record<string, ComponentType> = {
  "/": Landing,
  "/audit": Audit,
  "/score": ComplianceScore,
  "/privacy": PrivacyPolicy,
  "/terms": TermsOfService,
  "/impressum": Impressum,
  "/faq": FAQ,
  "/blog": Blog,
  "/afir-compliance-software": AfirComplianceSoftware,
  "/eichrecht-compliance": EichrechtCompliance,
  "/ladeinfrastruktur-compliance": LadeinfrastrukturCompliance,
  "/blog/afir-compliance-guide-2026": BlogAfirComplianceGuide2026,
  "/blog/eichrecht-konformitaet-checklist": BlogEichrechtKonformitaetChecklist,
  "/blog/cpms-buyer-checklist": BlogCpmsBuyerChecklist,
};

export async function prerender(data: { url: string }) {
  const Page = ROUTES[data.url];
  if (!Page) return { html: "" };
  const html = renderToString(
    <StaticRouter location={data.url}>
      <Page />
    </StaticRouter>,
  );
  return { html };
}
